import { useState, useEffect } from 'react';
import {
  AgxControlledCheckbox,
  AgxCurrency,
  AgxRow,
  AgxButton,
  Images,
} from '@urbanx/agx-ui-components';
import { Breakpoints, ScreenSize } from 'utils/screen';
import '../MarketingPackages.scss';
import { AgxTextInput } from '@urbanx/agx.ui-components2';

interface CustomMarketingItemProps {
  id: string;
  productName: string;
  pricePerUnit?: number;
  selected: boolean;
  validate?: boolean;
  onSelectProductChange: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
  deleteRow: (value: {
    id: string;
    productName: string;
    pricePerUnit?: number;
    value: boolean;
  }) => void;
}

const CustomMarketingItem = ({
  id,
  productName,
  pricePerUnit,
  selected,
  onSelectProductChange,
  deleteRow,
  validate,
}: CustomMarketingItemProps) => {
  const [customMarketingItem, setCustomMarketingItem] = useState(productName);
  const [price, setPrice] = useState(pricePerUnit);
  const [productSelected, setProductSelected] = useState(selected);

  const isTabletLandscapeSizeOrDesktopSize =
    ScreenSize() === Breakpoints.Tablet_Landscape ||
    ScreenSize() === Breakpoints.Desktop;

  useEffect(() => {
    setProductSelected(selected);
  }, [selected]);

  useEffect(() => {
    const number = Number(price);

    onSelectProductChange({
      id,
      productName: customMarketingItem,
      pricePerUnit: !Number.isNaN(price)
        ? number <= 0 || !number
          ? 0
          : number
        : 0,
      value: productSelected,
    });
  }, [productSelected, customMarketingItem, price]);

  const onValueChanged = (value: boolean) => {
    setProductSelected(value === true);
  };

  const onInputValueChange = ({ value }: { value: string | null }) => {
    const newValue = value?.toString()?.replace(/,/g, '');
    setPrice(newValue ? Number(newValue) : undefined);
  };

  const validateCustomMarketingItemName =
    validate && productSelected && customMarketingItem === '';

  const validateCustomMarketingItemPrice =
    validate && productSelected && (price === null || price === undefined);

  const validatingCustomMarketingItem =
    validateCustomMarketingItemName || validateCustomMarketingItemPrice;

  return (
    <AgxRow
      fill
      spaceBetween
      centered
      mediumGap
      extraClasses={`marketingPackageItem custom ${validatingCustomMarketingItem && 'error'}`}
    >
      <AgxControlledCheckbox
        naked
        checked={productSelected ?? true}
        onValueChanged={onValueChanged}
        id={id}
      />
      <AgxTextInput
        id="customMarketingItem"
        onInputValueChange={({ value }) => {
          setCustomMarketingItem(value);
        }}
        type={'text'}
        noHeader
        stretch
        size="large"
        defaultValue={customMarketingItem}
        errorText={validateCustomMarketingItemName ? 'Enter name' : undefined}
        hideErrorDescription
        required
      />
      <AgxCurrency
        id={`marketingpackage-item-text-${productName}-${id}`}
        defaultValue={
          price === null || price === undefined ? '' : price.toString()
        }
        onInputValueChange={onInputValueChange}
        decimalPoints={2}
        noHeader
        small
        alignRight
        formatDecimalsOnBlur
        placeholder="0.00"
        displayErrors={validateCustomMarketingItemPrice}
        error={validateCustomMarketingItemPrice ? 'Enter price' : undefined}
        validate={validateCustomMarketingItemPrice}
        extraClasses="customItemPrice"
      />
      <AgxButton
        minimal
        rightIcon={<Images.CrossFill />}
        extraClasses={
          isTabletLandscapeSizeOrDesktopSize
            ? 'marketingItemDeleteBtn'
            : undefined
        }
        onClick={() =>
          deleteRow({
            id: id,
            productName: customMarketingItem,
            pricePerUnit: !Number.isNaN(price) ? Number(price) : undefined,
            value: productSelected,
          })
        }
      />
    </AgxRow>
  );
};

export default CustomMarketingItem;
